import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IConfiguration } from "../Types/IConfiguration";

export interface IConfigurationState {
  configuration: IConfiguration;
}

export const initialState: IConfigurationState = {
  configuration: {
    Id: 0,
    Slide2: "",
    Slide3: "",
    ShowDuas: false,
  },
};

export const ConfigurationSlice = createSlice({
  initialState,
  name: "configuration",
  reducers: {
    setConfiguration: (
      state: IConfigurationState,
      { payload }: PayloadAction<IConfiguration>
    ): void => {
      state.configuration = payload;
    },
  },
});

export const configurationActions = ConfigurationSlice.actions;
export const configurationReducer = ConfigurationSlice.reducer;
